<template>
  <div class="">
    <div class="bb-container bb-container--config">
      <no-ssr>
        <portal-target name="alerts_configuration"></portal-target>
      </no-ssr>
    </div>

    <div class="g-user-sidebar">
      <div class="bb-container bb-container--config">
        <div class="g-user-sidebar__grid">
          <left-menu active="my-list"></left-menu>
          <div class="g-user-sidebar__content">
            <h2 class="g-user-sidebar__head">{{ $t("settings.myList") }}</h2>
            <div class="g-user-sidebar__main g-user-sidebar__main--lista">
              <div class="config-data">
                <div class="config-data__form">
                  <div class="bb-form-fieldset">
                    <div class="bb-form-item">
                      <div class="bb-form-label">{{ $t("generic.listName") }}</div>
                      <input
                        v-model="title"
                        class="bb-form"
                        type="text"
                        maxlength="256"
                        name="title"
                        id="title"
                        required=""
                        @blur="nameBlur"
                        :placeholder="$t('settings.listNamePlaceholder')"
                      />
                      <div class="bb-form-error" v-show="nameHasError">
                        {{ $t("generic.field_is_required") }}
                      </div>
                    </div>
                    <div class="bb-form-item">
                      <div class="bb-form-label">{{ $t("settings.welcomeMessage") }}</div>
                      <textarea
                        v-model="welcomeMessage"
                        class="bb-form-textarea"
                        type="text"
                        maxlength="1000"
                        rows="4"
                        name="welcomeMessage"
                        id="welcomeMessage"
                        required=""
                      />
                      <div class="bb-form-textarea-counter" :class="{ 'bb-form-textarea-counter--warning': welcomeMessageCharsLeft <= 50 }">
                        {{ welcomeMessage ? welcomeMessage.length : 0 }}/1000
                      </div>
                    </div>
                    
                    <div class="bb-form-item" v-if="list.type === 'wedding' || list.type === 'birthday' || list.type === 'home' || list.type === 'comunion'">
                      <div class="bb-form-label">{{$t("settings.whenIsTheEvent")}}</div>
                      <date-picker
                        id="dateEvent"
                        name="dateEvent"
                        v-model="childBirthdayIntern"
                      ></date-picker>
                    </div>

                  </div>
                  <div class="bb-form-fieldset" v-if="list.type === 'baby-registry' || list.type === 'babyshower'">
                    <h3 class="bb-form-fieldset__header">{{ $t("settings.babyInfo") }}</h3>

                    <div class="bb-form-item">
                      <div class="bb-form-label">{{ $t("settings.babyName") }}</div>
                      <input
                        v-model="childName"
                        class="bb-form"
                        type="text"
                        maxlength="256"
                        name="childName"
                        id="childName"
                        required=""
                        :placeholder="$t('settings.babyNamePlaceholder')"
                        @blur="childNameBlur"
                      />
                      <div class="bb-form-error" v-show="childNameHasError">
                        {{ $t("generic.field_is_required") }}
                      </div>
                    </div>

                    <div class="bb-form-item">
                      <div class="bb-form-label">{{$t("mylist.childBirthday")}}</div>
                      <date-picker
                        id="childBirthday"
                        name="childBirthday"
                        v-model="childBirthdayIntern"
                      ></date-picker>
                    </div>
                  </div>
                  <CollaboratorManager
                    v-if="isOwnerOfCurrentList"
                    :list-id="list.id"
                    :legacy-collaborator="user.partner || null"
                    :legacy-invitation="(user.invitationStatus === 'pending' && user.invitationText) ? user.invitationText : null"
                    @success="msg => $alert.success(msg, key)"
                    @error="msg => $alert.error(msg, key)"
                  />
                  <div v-else-if="currentListMatch" class="bb-form-fieldset">
                    <h3 class="bb-form-fieldset__header">
                      <span class="badge badge--light-indigo badge--rounded badge--sm">{{ $t("mylist.collaborator") }}</span>
                    </h3>
                    <div class="bb-form-item">
                      <div class="bb-form-label">{{ $t("settings.listOwner") }}</div>
                      <div class="bb-form-text">{{ currentListMatch.ownerName ? currentListMatch.ownerName + ' · ' + currentListMatch.ownerEmail : currentListMatch.ownerEmail }}</div>
                    </div>
                  </div>
                  <div v-if="user.stripeAccountId">
                    <div class="bb-form-fieldset">
                      <h3 class="bb-form-fieldset__header">{{ $t("settings.listPassword") }}</h3>
                      <div class="bb-form-item">
                        <div class="bb-form-label">{{ $t("login.password") }}</div>
                        <input
                          v-model="listPassword"
                          class="bb-form"
                          type="text"
                          maxlength="256"
                          name="listPassword"
                          id="listPassword"
                        />
                        <div class="bb-form-error" v-show="passwordHasError">
                          {{ $t("generic.field_is_required") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="config-data__actions">
                  <loading-button v-if="saving"></loading-button>
                  <button
                    v-else
                    class="button button--primary button--block"
                    @click.prevent="save"
                    :disabled="disabled"
                  >
                    {{ $t("generic.save") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <alert v-show="showAlertLocal" @retry="save()" />
      </div>
    </div>
  </div>
</template>

<script>
import { VTooltip } from "floating-vue";
import "floating-vue/dist/style.css";

import { mapGetters } from "vuex";
import LoadingButton from "../../components/LoadingButton";
import ConfigurationAlert from "./components/ConfigurationAlert";
import NoSSR from "vue-no-ssr";
import LeftMenu from "./components/LeftMenu";
import moment from "moment";
import DatePicker from "../../components/DatePicker";
import CanGetOwnerList from "../../Mixins/CanGetOwnerList";
import CollaboratorManager from "../../components/CollaboratorManager.vue";

moment.locale("moment_es");

export default {
  name: "ConfigurationMyListPage",
  mixins: [CanGetOwnerList],
  components: {
    LoadingButton,
    CollaboratorManager,
    "no-ssr": NoSSR,
    alert: ConfigurationAlert,
    LeftMenu,
    DatePicker
  },
  metaInfo() {
    return {
      title: this.$t("generic.settings") + " | HelloBB"
    };
  },
  data() {
    return {
      title: "",
      welcomeMessage: "",
      childBirthdayIntern: null,
      loading: false,
      errorMsg: null,
      saving: false,
      notDecided: false,
      childName: "",
      listPassword: "",
    };
  },
  directives: {
    tooltip: VTooltip
  },
  computed: {
    ...mapGetters({
      list: "ownerList",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
      user: "user"
    }),
    childNameHasError() {
      if (this.notDecided) {
        return false;
      }
      return this.childName === "" && this.childNameDirty;
    },
    currentListMatch() {
      const lists = this.user && this.user.lists;
      if (!lists || !this.list) return null;
      return lists.find((l) => l.id === this.list.id) || null;
    },
    isOwnerOfCurrentList() {
      return this.currentListMatch ? this.currentListMatch.role === "owner" : false;
    },
    childBirthday: {
      get() {
        if (!this.user) return null;
        const birthday = this.user.childBirthday;
        if (birthday === "0001-01-01T00:00:00" || birthday === "") {
          return null;
        }
        return moment(birthday).format("yyyy-MM-DD");
      },
      set(value) {
        this.childBirthdayIntern = value;
      }
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
    key() {
      return "configuration_page";
    },
    disabled() {
      return false;
      const isNameInvalid = this.name === "";

      const isCollaboratorInvalid = !this.collaboratorName || !this.collaboratorEmail || this.collaboratorEmailFormat;

      return isNameInvalid || isCollaboratorInvalid;
    },
    nameHasError() {
      return this.name === "" && this.nameDirty;
    },
    passwordHasError() {
      return this.listPassword === "" && this.passwordDirty;
    },
    passwordDirty() {
      return this.listPasswordDirty;
    },
    welcomeMessageCharsLeft() {
      return 1000 - (this.welcomeMessage ? this.welcomeMessage.length : 0);
    }
  },
  methods: {
    childNameBlur() {
      this.childNameDirty = true;
      if (this.childName !== "") this.notDecided = false;
    },
    getImgUrl() {
      return process.env.URL_IMG_USER + this.user.photo;
    },
    async save() {
      this.saving = true;
      try {
        if (this.list.type === "baby-registry" || this.list.type === "babyshower" || this.list.type === "wedding" || this.list.type === "birthday" || this.list.type === "home" || this.list.type === "comunion") {  
          if (this.childBirthdayIntern) {
            await this.$store.dispatch("updateChildBirthday", this.childBirthdayIntern);
            this.$store.commit("updateUserField", {
              field: "childBirthday",
              value: this.childBirthdayIntern
            });
          }
          const childName = !this.childName ? "TBD" : this.childName;
          if(childName)
          {
            await this.$store.dispatch("updateChildName", childName);
            this.$store.commit("updateUserField", {
              field: "childName",
              value: childName
            });
          }
        }

        await this.$store.dispatch("updateListTitle", {
          list: this.list,
          title: this.title
        });
        if (this.welcomeMessage) {
          await this.$store.dispatch("updateWelcomeMessage", this.welcomeMessage);
        }
        if (this.listPassword) {
          await this.$store.dispatch("patchListPwd", this.listPassword);
        }
      } catch (error) {
        console.log(error);
        this.saving = false;
        this.$alert.error(this.$t("generic.errorNoSave"), this.key);
        return;
      }
      await this.$store.dispatch("getOwnerList");
      this.$alert.success(this.$t("generic.saveMessage"), this.key);
      this.saving = false;
    },
    nameBlur() {
      this.nameDirty = true;
    },
  },
  mounted() {
    this.title = this.list.title;
    this.welcomeMessage = this.list.welcomeMessage;
    this.listPassword = this.list.password;
    this.childBirthdayIntern = this.list.childBirthday;
    if (this.list.childName === "TBD") {
      this.childName = "";
      this.notDecided = true;
    } else {
      this.childName = this.list.childName;
    }
  }
};
</script>
